import { backendApi } from "@/services/api";
import type { Mould } from "@/services/backend/mould/mould";
import { SampleError } from "@/services/backend/sample-error/sample-error";
import { Filter } from "@/shared/lib/filter/filter";

const mouldsApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    createMould: build.mutation<SampleError, PutRequest>({
      query: (request) => ({
        url: `/moulds`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Mould"],
    }),
    getMould: build.query<Mould, GetRequest>({
      query: (request) => ({
        url: `/moulds/${request.id}`,
        method: "GET",
        params: request,
      }),
      providesTags: (_result, _e, request) => [
        { type: "Mould", id: request.id },
      ],
    }),
    listMoulds: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/moulds`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: "Mould" as const,
                id,
              })),
              { type: "Mould", id: "LIST" },
            ]
          : [{ type: "Mould", id: "LIST" }],
    }),
    deleteMould: build.mutation<DeleteResponse, DeleteRequest>({
      query: (request) => ({
        url: `/moulds`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["Mould"],
    }),
  }),
});

export const {
  useCreateMouldMutation,
  useGetMouldQuery,
  useListMouldsQuery,
  useDeleteMouldMutation,
} = mouldsApi;

export interface PutRequest {
  mould: Mould;
}

export interface ListRequest {
  description?: Filter<string>;
  isYeast?: Filter<boolean>;
}

export interface List {
  count: number;
  items: Mould[];
}

export interface GetRequest {
  id: string;
}

export interface DeleteRequest {
  id: string;
}

export interface DeleteResponse {}
